// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../types/schema';

import { CharitableTrustDesignerIllustrationData_CrtProposalFragment, CharitableTrustDesignerIllustrationData_CltProposalFragment } from '../../designer/CharitableTrustDesigner/CharitableTrustDesignerAnalysis/graphql/CharitableTrustDesignerIllustrationData.generated';
import { gql } from '@apollo/client';
import { CharitableTrustDesignerIllustrationData_CrtProposalFragmentDoc, CharitableTrustDesignerIllustrationData_CltProposalFragmentDoc } from '../../designer/CharitableTrustDesigner/CharitableTrustDesignerAnalysis/graphql/CharitableTrustDesignerIllustrationData.generated';
export type CharitableProposalFragment_BeneficiaryFragment = { __typename?: 'Beneficiary', id: string, organization?: { __typename?: 'ClientOrganization', id: string, name: string } | null, individual?: { __typename?: 'ClientProfile', id: string, displayName: string } | null, entity?: { __typename?: 'Entity', id: string, subtype: { __typename?: 'CCorpBusinessEntity', id: string, displayName: string } | { __typename?: 'CLTTrust', id: string, displayName: string } | { __typename?: 'CRTTrust', id: string, displayName: string } | { __typename?: 'CustodialPersonalAccount', id: string, displayName: string } | { __typename?: 'DonorAdvisedFund', id: string, displayName: string } | { __typename?: 'GPBusinessEntity', id: string, displayName: string } | { __typename?: 'GRATTrust', id: string, displayName: string } | { __typename?: 'ILITTrust', id: string, displayName: string } | { __typename?: 'IndividualPersonalAccount', id: string, displayName: string } | { __typename?: 'InsurancePersonalAccount', id: string, displayName: string } | { __typename?: 'IrrevocableTrust', id: string, displayName: string } | { __typename?: 'JointPersonalAccount', id: string, displayName: string } | { __typename?: 'LLCBusinessEntity', id: string, displayName: string } | { __typename?: 'LPBusinessEntity', id: string, displayName: string } | { __typename?: 'PrivateFoundation', id: string, displayName: string } | { __typename?: 'QPRTTrust', id: string, displayName: string } | { __typename?: 'QualifiedTuitionPersonalAccount', id: string, displayName: string } | { __typename?: 'RetirementPersonalAccount', id: string, displayName: string } | { __typename?: 'RevocableTrust', id: string, displayName: string } | { __typename?: 'SCorpBusinessEntity', id: string, displayName: string } | { __typename?: 'SLATTrust', id: string, displayName: string } | { __typename?: 'SoleProprietorshipBusinessEntity', id: string, displayName: string } } | null, testamentaryEntity?: { __typename?: 'TestamentaryEntity', id: string, displayName: string } | null, accessParameters: { __typename?: 'AccessParameterConnection', edges?: Array<{ __typename?: 'AccessParameterEdge', node?: { __typename?: 'AccessParameter', id: string, percentage?: Percent | null } | null } | null> | null } };

export type CharitableProposalFragment_Donor_ClientProfileFragment = { __typename?: 'ClientProfile', id: string, displayName: string, dateOfBirth?: Time | null };

export type CharitableProposalFragment_CrtProposalFragment = (
  { __typename?: 'CRTProposal', id: string, assetValue: CurrencyUSD, assetCostBasis: CurrencyUSD, assetNotes?: string | null, payoutKind: Types.CharitableTrustPayoutKind, payoutFrequency: Types.CharitableTrustPayoutFrequency, annuityPayoutAmount?: CurrencyUSD | null, unitrustPayoutPercent?: Percent | null, termYears: number, termKind: Types.CharitableTrustTermKind, rate7520?: Percent | null, preTaxReturnPercentageHigh?: Percent | null, preTaxReturnPercentageMedium?: Percent | null, preTaxReturnPercentageLow?: Percent | null, taxDragPercentageHigh?: Percent | null, taxDragPercentageMedium?: Percent | null, taxDragPercentageLow?: Percent | null, yearOfAnalysis?: number | null, donors: Array<(
    { __typename?: 'ClientProfile' }
    & CharitableProposalFragment_Donor_ClientProfileFragment
  )>, incomeBeneficiaries?: Array<(
    { __typename?: 'Beneficiary' }
    & CharitableProposalFragment_BeneficiaryFragment
  )> | null, charitableRemainderBeneficiaries?: Array<(
    { __typename?: 'Beneficiary' }
    & CharitableProposalFragment_BeneficiaryFragment
  )> | null }
  & CharitableTrustDesignerIllustrationData_CrtProposalFragment
);

export type CharitableProposalFragment_CltProposalFragment = (
  { __typename?: 'CLTProposal', id: string, assetValue: CurrencyUSD, assetCostBasis: CurrencyUSD, assetNotes?: string | null, payoutKind: Types.CharitableTrustPayoutKind, payoutFrequency: Types.CharitableTrustPayoutFrequency, annuityPayoutAmount?: CurrencyUSD | null, unitrustPayoutPercent?: Percent | null, termYears: number, termKind: Types.CharitableTrustTermKind, rate7520?: Percent | null, preTaxReturnPercentageHigh?: Percent | null, preTaxReturnPercentageMedium?: Percent | null, preTaxReturnPercentageLow?: Percent | null, taxDragPercentageHigh?: Percent | null, taxDragPercentageMedium?: Percent | null, taxDragPercentageLow?: Percent | null, yearOfAnalysis?: number | null, charitableIncomeBeneficiaries?: Array<(
    { __typename?: 'Beneficiary' }
    & CharitableProposalFragment_BeneficiaryFragment
  )> | null, remainderBeneficiaries?: Array<(
    { __typename?: 'Beneficiary' }
    & CharitableProposalFragment_BeneficiaryFragment
  )> | null, donors: Array<(
    { __typename?: 'ClientProfile' }
    & CharitableProposalFragment_Donor_ClientProfileFragment
  )> }
  & CharitableTrustDesignerIllustrationData_CltProposalFragment
);

export const Operations = {
  Fragment: {
    CharitableProposalFragment_Beneficiary: 'CharitableProposalFragment_Beneficiary' as const,
    CharitableProposalFragment_donor_ClientProfile: 'CharitableProposalFragment_donor_ClientProfile' as const,
    CharitableProposalFragment_CRTProposal: 'CharitableProposalFragment_CRTProposal' as const,
    CharitableProposalFragment_CLTProposal: 'CharitableProposalFragment_CLTProposal' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const CharitableProposalFragment_Donor_ClientProfileFragmentDoc = gql`
    fragment CharitableProposalFragment_donor_ClientProfile on ClientProfile {
  id
  displayName
  dateOfBirth
}
    `;
export const CharitableProposalFragment_BeneficiaryFragmentDoc = gql`
    fragment CharitableProposalFragment_Beneficiary on Beneficiary {
  id
  organization {
    id
    name
  }
  individual {
    id
    displayName
  }
  entity {
    id
    subtype {
      id
      displayName
    }
  }
  testamentaryEntity {
    id
    displayName
  }
  accessParameters {
    edges {
      node {
        id
        percentage
      }
    }
  }
}
    `;
export const CharitableProposalFragment_CrtProposalFragmentDoc = gql`
    fragment CharitableProposalFragment_CRTProposal on CRTProposal {
  id
  assetValue
  assetCostBasis
  assetNotes
  payoutKind
  payoutFrequency
  annuityPayoutAmount
  unitrustPayoutPercent
  termYears
  termKind
  rate7520
  preTaxReturnPercentageHigh
  preTaxReturnPercentageMedium
  preTaxReturnPercentageLow
  taxDragPercentageHigh
  taxDragPercentageMedium
  taxDragPercentageLow
  yearOfAnalysis
  donors {
    ...CharitableProposalFragment_donor_ClientProfile
  }
  incomeBeneficiaries {
    ...CharitableProposalFragment_Beneficiary
  }
  charitableRemainderBeneficiaries {
    ...CharitableProposalFragment_Beneficiary
  }
  ...CharitableTrustDesignerIllustrationData_CRTProposal
}
    ${CharitableProposalFragment_Donor_ClientProfileFragmentDoc}
${CharitableProposalFragment_BeneficiaryFragmentDoc}
${CharitableTrustDesignerIllustrationData_CrtProposalFragmentDoc}`;
export const CharitableProposalFragment_CltProposalFragmentDoc = gql`
    fragment CharitableProposalFragment_CLTProposal on CLTProposal {
  id
  assetValue
  assetCostBasis
  assetNotes
  payoutKind
  payoutFrequency
  annuityPayoutAmount
  unitrustPayoutPercent
  termYears
  termKind
  rate7520
  preTaxReturnPercentageHigh
  preTaxReturnPercentageMedium
  preTaxReturnPercentageLow
  taxDragPercentageHigh
  taxDragPercentageMedium
  taxDragPercentageLow
  yearOfAnalysis
  charitableIncomeBeneficiaries {
    ...CharitableProposalFragment_Beneficiary
  }
  remainderBeneficiaries {
    ...CharitableProposalFragment_Beneficiary
  }
  donors {
    ...CharitableProposalFragment_donor_ClientProfile
  }
  ...CharitableTrustDesignerIllustrationData_CLTProposal
}
    ${CharitableProposalFragment_BeneficiaryFragmentDoc}
${CharitableProposalFragment_Donor_ClientProfileFragmentDoc}
${CharitableTrustDesignerIllustrationData_CltProposalFragmentDoc}`;